const checkoutButtons = () =>
  [document.getElementById("checkout"), document.getElementById("CartDrawer-Checkout")].filter(Boolean);

function isCartEmpty() {
  const cartDrawer = document.querySelector("cart-drawer");
  const cartFooter = document.getElementById("main-cart-footer");

  return (
    (cartDrawer && cartDrawer.classList.contains("is-empty")) ||
    (cartFooter && cartFooter.classList.contains("is-empty"))
  );
}

function getVisibleTermsCheckbox() {
  return [...document.querySelectorAll(".cart-checkout-terms__checkbox")].find(
    (checkbox) => checkbox.offsetParent !== null
  );
}

function syncCheckoutState() {
  const buttons = checkoutButtons();
  if (!buttons.length) return;

  const isEmpty = isCartEmpty();
  const visibleCheckbox = getVisibleTermsCheckbox();
  const termsAccepted = visibleCheckbox ? visibleCheckbox.checked : false;

  buttons.forEach((button) => {
    button.disabled = isEmpty || !termsAccepted;
  });
}

function initCartCheckoutTerms() {
  document.querySelectorAll(".cart-checkout-terms__checkbox").forEach((checkbox) => {
    if (checkbox.dataset.termsInitialized === "true") return;
    checkbox.dataset.termsInitialized = "true";
    checkbox.addEventListener("change", syncCheckoutState);
  });

  syncCheckoutState();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartCheckoutTerms);
} else {
  initCartCheckoutTerms();
}

document.addEventListener("cart:updated", () => {
  initCartCheckoutTerms();
  syncCheckoutState();
});
